import React from 'react';

const PlanningPage: React.FC = () => {
    return (
        <div>
            PlanningPage
        </div>
    );
};

export { PlanningPage }
